import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import userReducer from './slices/authSlice';
import { userAuthApis } from './services/user/user';
import { cloudlabApi } from './services/cloudlab/cloudlab';
import uiReducer from './slices/Sidebar';
import notificationReducer from './slices/NotificationSystemSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import urlReducer from './slices/PersistInstanceSlice';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    user: userReducer,
    ui: uiReducer,
    notification: notificationReducer,
    url: urlReducer,
    [userAuthApis.reducerPath]: userAuthApis.reducer,
    [cloudlabApi.reducerPath]: cloudlabApi.reducer,
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user', 'url'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            userAuthApis.middleware,
            cloudlabApi.middleware
        ),
});

export const persistor = persistStore(store);
// Enable refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export const RootState = store.getState;
export const AppDispatch = store.dispatch;